<template>
    <div class="publicViewClass" style="padding-top:0">
         <div  class="app-inner">
              <div class="preview-nav flex align-cen">
            <div class="preview-nav-left flex align-cen">
                <i class="icon-al-exclamation-circle"></i>
                <span>提示：预览过程中只看效果，不保存数据</span>
            </div>
            <div class="mft">
                <div class="close" @click="$util.reback('/testPapeList')">关闭</div>
            </div>
        </div>
        <div class="preview-content">
             <div class="new-content-panel flex">
                <div class="exam-metas" v-if="sourceData.paper">
                    <div class="metas">
                        <p class="metas-p">{{sourceData.paper.paperName}}</p>
                        <div class="time-left">
                            <div class="time-main">
                                <strong>
                                    <span>
                                        <el-statistic :value="deadline" 
                                        ref="statistic"
                                        time-indices
                                         format="HH:mm:ss"
                                          @finish="hilarity"
                                        >
                                            </el-statistic>
                                    </span>
                                </strong>
                            </div>
                            <div class="time-tip flex align-cen">
                                <span class="icon-al-clock"></span>
                                总剩余时间
                            </div>
                            <div class="page">总题数：{{sourceData.questionMapList.length}}</div>
                        </div>
                        <div class="questions-card">
                            <span>
                                <strong>题卡</strong>
                            </span>
                        </div>
                        <div class="questions-lists">
                            <div class="q-list">
                                <ul>
                                    <li v-for="(item,index) in sourceData.questionMapList" :class="item.isAnswer == 1 ? 'Answeral' :''"
                                    >{{index + 1}}</li>
                                </ul>
                            </div>
                        </div>
                        <div class="metas-footer">
                            <div class="questipn-lists-icon flex align-cne">
                                <span class="allright flex align-cen">
                                    <i></i>
                                    已做
                                </span>
                                <span class="noright flex align-cen">
                                    <i></i>
                                    未做
                                </span>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="doexam-main publicScroolbar">
                   <div class="row">
                    <div class="question" v-if="questionDetailList">
                        <div class="question-main-content" v-for="(item,index) in questionDetailList" :key="item.id">
                            <div class="ques-title flex align-cen">
                                <p class="ques-number">{{indexShow}}.</p>
                                <p class="ques-type">[{{item.type == 1 ? '单选题' : item.type == 2 ? '多选题' : item.type== 3 ? '判断题' : item.type == 4 ? '填空题' : ''}}]</p>
                                <p class="title-pre" v-html="item.title"></p>
                                <p class="ques-score">（{{item.score}}分）</p>
                            </div>
                     <div class="ques-answers">
                            <ul>
                                <li v-for="(sonitem,sonIndex) in item.answerList" :key="sonitem.id" :class="radio == sonitem.id ? 'liActive' : ''"
                                >
                                     <el-radio v-model="radio" :label="sonitem.id"
                                    @change="showChage(sonitem.questionId)"
                                    class="flex align-cen"
                                     >
                                     <div class="flex align-cen">
                                        {{Eng[sonIndex]}}.<div v-html="sonitem.content"></div>
                                     </div>
                                     </el-radio>   
                                </li>
                            </ul>
                        </div> 
                        </div>
                        <div class="downtip" v-if="showReminder">
                            <p class="num">{{countDown}}</p> 
                            <p>自动交卷倒计时</p>
                        </div>
                        <div class="submit-buttons flex align-cen">
                            <div class="backPage btn" v-if="indexShow!=1">上一题</div>
                            <div class="nextPage btn">下一题</div>
                        </div>
                    </div>
                   </div>
                </div>
             </div>
        </div>
         </div>
    </div>
</template>
<script>
export default {
    name:'listexams',
    data () {
        return {
        deadline:'',
        showReminder:false,
        countdown:5,  
        timer:null,
        centerDialogVisible:true,
        indexShow:'',
        tes:[],
        deadline2: Date.now() + 1000 * 60 * 30,
        radio:'',
         wsUrl: "",//定义socket连接地址
        sourceData:{},
        Eng:['A','B','C','D','E','F','G','H','I','J'],
        questionDetailList:[],
        countDown: '', // 倒计时时间
        timer: null // 定时器
        }
    },
    created () {
             this.webSocketData('');
             this.indexShow = 1
    },
    mounted(){
    },
        //离开页面关闭socket
 destroyed() {
     //在离开此页面的时候主动关闭socket
         this.$socketApi.closeWebsocket()
        clearInterval(this.timer);
  },
    methods: {
        // 倒计时结束
        hilarity(){
        this.$notify.error({
          title: "温馨提示",
          message: "时间已到，交卷中，请勿刷新页面",
          duration: 2000,
        });
        },
        showChage(questionId){
            let arr = this.questionMapList
             for (const key in arr) {
               if(arr[key].questionId == questionId){
                if(arr[key].isAnswer == 0) arr[key].isAnswer = 1
               }
             }
             this.questionMapList = arr
        },
              webSocketData(questionId){
            let wsUrl = `ws://${this.$config.baseUrl}/ws/${this.$route.query.id}?token=&businessId=&view=preview`
            let params = {
                type:'questionDetail',
                questionIds:questionId? questionId : []
            }
            //  this.wsUrl = new WebSocket(en)
            //   // 监听连接打开事件  
            //         this.wsUrl.onopen = () => {  
            //             console.log('WebSocket连接已打开！');  
            //             // 在此处可以发送消息到服务器  
            //         }; 
            //     this.wsUrl.onmessage = (event) => {  
            //         console.log('收到服务器消息：', event.data);  
            //         // 在此处可以处理从服务器接收到的消息  
            //     };
            this.$socketApi.connectWebsocket(wsUrl,params,(res) => {
                    let datas = JSON.parse(res)
                  if(datas.code == 0 ){
                    if(datas.data.paper){
                          this.sourceData = datas.data
                        //   datas.data.paper.answerTimeLimit
                          this.deadline = Date.now() + 1000 * 60 * datas.data.paper.answerTimeLimit
                          this.countDown = Number((datas.data.paper.answerTimeLimit * 60) - 1)
                          console.log(this.countDown)
                          this.startCountDown()
                          if(!questionId){
                            params.questionIds.push(datas.data.questionMapList[0].questionId) 
                          }
                          this.$socketApi.onWsOpen(params)
                    }else if(this.questionDetailList){
                        this.questionDetailList = datas.data.questionDetailList
                    }
                  }
                    },
                    () => {
                        console.log("失败的回调函数");
                    }
                    );
        },
                     startCountDown() {
                        this.timer = setInterval(() => {
                        if (this.countDown > 0) {
                        this.countDown--;
                        if(this.countDown == 5){
                            this.showReminder = true
                        }
                        } else {
                            this.showReminder = false
                        clearInterval(this.timer);
                        }
                        }, 1000);
                        }
    }
}
</script>
<style lang="scss" scoped>
.downtip{
    position: absolute;
    width: 250px;
    height: 150px;
    background: #fff;
    box-shadow: 0 4px 8px 0 rgba(7, 17, 27, 0.1);
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    border-radius: 5px;
    text-align: center;
    .num{
        color: red;
        font-size: 34px;
        padding-top: 20px;
        padding-bottom: 10px;
    }
}
.app-inner{
   background:#f7f8fa ;
      border-radius: 10px;
   .preview-nav{
     background:#fff ;
     margin-left: -16px;
     margin-top: -16px;
     width: calc(100% + 32px);
    border-radius: 10px 10px 0 0;
    padding-bottom: 16px;
    padding-top: 16px;
    .preview-nav-left{
        padding-left: 2%;
        margin-top: 10px;
        width: 350px;
        i{
            color: red;
            font-size: 20px;
        }
        span{
            font-size: 16px;
            color: red;
            margin-left: 1%;
        }
    }
    .mft{
        margin-right: 20px;
        .close{
            width: 74px;
    height: 42px;
    border-radius: 4px!important;
    border: solid 1px #e6e6e6;
    text-align: center;
    cursor: pointer;
    line-height: 42px;
        }
    }
   }
   .preview-content{
    .new-content-panel{
        position: relative;
    margin-right: auto;
    margin-left: auto;
    margin-top: 70px;
    width: 970px;
    border-radius: 5px;
    height: 715px;
    position: absolute;
    padding-bottom: 50px;
    left: 50%;
    transform: translateX(-50%);
    .exam-metas{
        width: 210px;
            background: #fff;
        .metas{
    position: relative;
    padding: 0 10px;
    background-color: #fff;
    margin-bottom: 13px;
    text-align: center;
    height: 100%;
    .metas-p{
     padding-top: 11px;
    overflow: hidden;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    white-space: normal;
    }
    .time-left{
       margin: 21px 0 10px;
       border-top: 1px solid #e6e6e6;
        border-bottom: 1px solid #e6e6e6;
       .time-main{
        margin-top: 11px;
        span{
           font-size: 34px;
            color: #36aafd;
            font-weight: 400; 
        }
       }
       .time-tip{
        color: #666;
        font-size: 16px;
        justify-content: center;
    span{
        color: #36aafd;
        font-size: 20px;
    }
       }
       .page{
            margin: 25px 0;
    font-size: 16px;
    color: #333;
    padding: 5px 0;
       }
    }
    .questions-card{
    font-size: 14px;
    margin-top: 20px;
    margin-bottom: 5px;
    }
    .questions-lists{
     max-height: 290px;
    overflow-y: auto;
    margin-bottom: 10px;
    padding-right: 0; 
    padding: 10px;
    .q-list{
      ul{
        li{
           font-size: 12px;
    display: block;
    padding: 2px 0;
    border: 1px solid #bbb;
    border-radius: 2px;
    float: left;
    margin-right: 9px;
    margin-bottom: 9px;
    min-width: 25px;
    color: #666;
    position: relative;
    cursor: pointer;
    box-sizing: border-box;
        }
        .Answeral{
            background: #36aafd;
            color: #fff;
            border: none;
        }
      }
    }
    }
    .metas-footer{
        margin-top: 20px;
    .questipn-lists-icon{
        justify-content: center;
        span{
            margin-bottom: 10px;
            color: #aaa;
            margin-right: 10px;
        }
                   .allright{
              i{
                display: block;
                width: 16px;
                height: 16px;
                border-radius: 5px;
                background: #36aafd;
               margin-right: 5px;
              }
            }
            .noright{
                i{
                display: block;
                width: 16px;
                height: 16px;
                border-radius: 5px;
               border: 1px solid #aaa;
               box-sizing: border-box;
                margin-right: 5px;
                }
            }
    }
    }
        }
    }
    .doexam-main{ 
    background-color: #fff;
    margin: 0 15px;
    flex-grow: 1;
    overflow: hidden;
    overflow-y: auto;
    .question{
        padding: 0 15px;
        position: relative;
        .question-main-content{
            margin-top: 15px;
         margin-bottom: 15px;
         .ques-title{
            font-size: 16px;
            line-height: 30px;
            hyphens: auto;
            -ms-hyphens: auto;
            text-align: justify;
            .ques-number{
                line-height: 27px;
                color: #36aafd;
                border-color: #36aafd;
                padding-top: 2px;
                margin-right: 3px;
            }
           .ques-type{
                 margin-right: 10px;
                vertical-align: middle;
                color: #36aafd;
                }
                                .title-pre{
                    white-space: normal!important;
                }
                .ques-score{
                    color: #aeaeae;
                }
         }
                .ques-answers{
            margin-top: 15px;
            ul{
                li{
                    font-size: 14px;
                        white-space: normal;
                        background-color: #fff;
                        border-color: #eaeaea;
                        text-align: left;
                        margin-bottom: 10px;
                        padding: 10px 12px;
                        font-weight: 400;
                        line-height: 1.42857143;
                        white-space: nowrap;
                        vertical-align: middle; 
                        -ms-touch-action: manipulation;
                        touch-action: manipulation;
                        cursor: pointer;
                        -webkit-user-select: none;
                        -moz-user-select: none;
                        -ms-user-select: none;
                        user-select: none;
                        background-image: none;
                        border: 1px solid #eaeaea;
                        border-radius: 4px;
                }
                li:hover{
                    background-color: #fff;
                border-color: #009aff;
                }
                .liActive{
                  border: 2px solid #009aff;
                }
            }
         }
        }
    }
    .submit-buttons{
    background-color: #fff;
    padding: 40px 80px 50px;
    margin-bottom: 0;
    margin-top: 100px;
    .btn{
    padding: 10px 0;  
    flex-grow: 1;
        background: #fff;
        margin-bottom: 0;
    font-size: 14px;
    font-weight: 400;
    line-height: 1.42857143;
    text-align: center;
    white-space: nowrap;
    vertical-align: middle;
    -ms-touch-action: manipulation;
    touch-action: manipulation;
    cursor: pointer;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
    background-image: none;
    border-radius: 4px;
    margin-right: 10px;
    }
    .backPage{
    color: #36aafd;
     border: 1px solid #36aafd;
    }
    .nextPage{
    color: #fff;
    background-color: #36aafd;
    border: none;
    }
    }
    }
    }
   }
}
::v-deep{
    .el-statistic{
    font-weight: 400;
    .number{
    font-size: 34px;
    color: #36aafd;
    }
    }
}
</style>